import { clsx, type ClassValue } from 'clsx';
import { isNil } from 'lodash';
import { twMerge } from 'tailwind-merge';
import { format } from 'date-fns';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function valueOrUndefined<T>(
  value: T | null | undefined
): T | undefined {
  return isNil(value) || value === '' ? undefined : value;
}

export function valueOrNull<T>(value: T | null | undefined): T | null {
  return isNil(value) || value === '' ? null : value;
}

export function valueOrDash(value: string | null | undefined): string {
  return isNil(value) || value === '' ? '-' : value;
}

export function formatDate(date: string) {
  return format(new Date(date), 'dd/MM/yyyy');
}

export function toDateStringForDirectus(date: Date) {
  return format(date, 'yyyy-MM-dd');
}

export function isValidUrl(
  url: string,
  allowedProtocols = ['http:', 'https:']
): boolean {
  try {
    const parsed = new URL(url);
    return allowedProtocols.includes(parsed.protocol);
  } catch {
    return false;
  }
}
